<div class="d-flex flex-column protection-plans">
  <div class="d-flex align-items-center justify-content-between">
    <h2 class="semi-bold">Protection plans</h2>
    <div
      *ngIf="!ancillaryUpsell"
      data-id="protection-edit"
      (click)="editClick.emit()"
      class="cursor-pointer d-flex align-items-center text-travalign-main"
    >
      <img src="assets/icons/edit.svg" alt="edit" />
      <p class="ml-2 semi-bold">Edit</p>
    </div>
  </div>

  <div class="d-flex flex-column protection-plans-container">
    @for (protection of protections; track protection) {
      <div data-id="protection" class="d-flex align-items-center">
        <img
          data-id="protection-icon"
          height="20px"
          width="20px"
          class="mr-2"
          src="assets/icons/{{ protection.img }}.svg"
          [alt]="protection.img"
        />
        <p data-id="protection-label">{{ protection.label }}</p>
      </div>
    }
  </div>
</div>
